/**
 * @file paddlex 用户信息
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import { Button, Alert, Result } from 'antd';
import Header from '../../../../components/header/HeaderWithStore';
import Banner from '../../../../components/banner/Banner';
import Footer from '../../../../components/footer/footer';
import UserInfoForm from './components/user-info-form/UserInfoForm';
import useUserInfoHooks from './CustomerInfoHooks';
import { Link } from 'react-router-dom';
const UserInfo: React.FC = () => {
    const {
        isSuccess,
        resultMessage,
        time,
        userInfoForm,
        // verifyCodeImg,
        // getVerifyCode,
        careerType,
        onFormSubmit,
        onFormCancel,
        handleCareerTypeChange,
        industryInput,
        onIndustryInputChange,
        industryData,
        addItem,
        selectOpen,
        setSelectOpen
    } = useUserInfoHooks();

    return (
        <div className="page paddle-lab-user-info-page">
            <Header />
            {isSuccess ? (
                <div className={'paddle-lab-user-info-result'}>
                    <Result
                        status="success"
                        title="提交成功"
                        subTitle={resultMessage}
                        extra={[
                            <Button type="primary" size="large" key="1">
                                <Link to="/install/other?docurl=/documentation/docs/zh/install/docker/linux-docker.html">
                                    返回安装页
                                </Link>
                            </Button>,
                            <p className={'paddle-lab-user-info-result-p'} key="2">
                                {`${time}`}s后将自动返回安装页
                            </p>
                        ]}
                    />
                </div>
            ) : (
                <>
                    <Banner
                        title="个人信息"
                        className="paddle-lab-user-info-banner"
                        subtitle="为了更好的了解您的实际需求，方便您与飞桨团队反馈交流，烦请您填写个人基本信息，感谢您对飞桨团队的支持与配合！"
                        divider
                    />
                    <div className="paddle-lab-user-info-container">
                        <Alert
                            className="paddle-lab-user-info-alert"
                            message="下载链接将会在您提交个人基本信息后生成"
                            type="info"
                        />
                        <UserInfoForm
                            {...{
                                isSuccess,
                                resultMessage,
                                time,
                                userInfoForm,
                                // verifyCodeImg,
                                // getVerifyCode,
                                careerType,
                                onFormSubmit,
                                onFormCancel,
                                handleCareerTypeChange,
                                industryInput,
                                onIndustryInputChange,
                                industryData,
                                addItem,
                                selectOpen,
                                setSelectOpen
                            }}
                        />
                    </div>
                    <Footer />
                </>
            )}
        </div>
    );
};

export default UserInfo;
